import {getToken, logout} from './auth-store';

const apiUrl = 'API_URL';

export async function apiFetch(url, options) {
  if (!options) {
    options = {};
  }
  if (!options.headers) {
    options.headers = {};
  }

  if (!getToken()) {
    logout();
    return;
  }

  options.headers = {
    'Authorization': 'Bearer ' + getToken(),
  };

  url = apiUrl + url;

  return fetch(url, options).then((response) => {
    if (response.status === 401) {
      logout();
    }

    return response.json();
  }).catch((error) => {
    console.error(error);
  });
}

export async function apiPost(url, data, options) {
  if (!options) {
    options = {};
  }
  if (!options.headers) {
    options.headers = {};
  }

  if (!getToken()) {
    logout();
    return;
  }

  options.method = 'POST';
  options.body = JSON.stringify(data);

  options.headers = {
    'Authorization': 'Bearer ' + getToken(),
    'Content-Type': 'application/json',
  };

  if(!url.startsWith('http')) {
    url = apiUrl + url;
  }

  return fetch(url, options).then((response) => {
    if (response.status === 401) {
      logout();
    }

    return response.json();
  }).catch((error) => {
    console.error(error);
  });


}